import { render, staticRenderFns } from "./MockListPatientGroups.vue?vue&type=template&id=d5b34b20&scoped=true&"
import script from "./MockListPatientGroups.vue?vue&type=script&lang=js&"
export * from "./MockListPatientGroups.vue?vue&type=script&lang=js&"
import style0 from "./MockListPatientGroups.vue?vue&type=style&index=0&id=d5b34b20&prod&scoped=true&lang=css&"
import style1 from "./MockListPatientGroups.vue?vue&type=style&index=1&id=d5b34b20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b34b20",
  null
  
)

export default component.exports